/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type BookingStatus = "BOOKED" | "CANCELED" | "INITIAL" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchContainer_viewer$ref: FragmentReference;
export type SearchContainer_viewer = {|
  +s_time_zone: ?string,
  +user_event_search: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +event: ?{|
          +id: string,
          +title: ?string,
        |},
        +booking_status: ?BookingStatus,
        +start_at: ?any,
        +end_at: ?any,
        +user_event_segments: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +location: ?string
            |}
          |}>
        |},
      |}
    |}>
  |},
  +$refType: SearchContainer_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchContainer_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": 3
    },
    {
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "s_time_zone",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user_event_search",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 3,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query",
          "type": "String!"
        }
      ],
      "concreteType": "UserEventConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "UserEventEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "UserEvent",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "event",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Event",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "id",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "title",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "booking_status",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "start_at",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "end_at",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "user_event_segments",
                  "storageKey": "user_event_segments(first:1)",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 1,
                      "type": "Int"
                    }
                  ],
                  "concreteType": "UserEventSegmentConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "UserEventSegmentEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "UserEventSegment",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "location",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6992d655ca6b9b91f5e5afcfaffd6e4d';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/App/__generated__/SearchContainer_viewer.graphql.js